import axios from "axios";

const instance = axios.create({
  baseURL :`${process.env.REACT_APP_API_URL}api/`
})


// This is only for LOCAL
// const instance = axios.create({
//   baseURL: `http://localhost:4040/api`,
// });

// Add an interceptor to set the authorization token for each request
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // Get the token from localStorage

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
